import { useEffect } from "react";

// Sets the Organization JSON-LD once at the document level.
// This declares UKTDA as the parent entity and explicitly lists the three
// sub-brand domains via `sameAs`, so Google treats the four sites as one
// related entity graph.
export default function OrganizationSchema() {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "UK Train Driver Academy Ltd",
      alternateName: "UKTDA",
      url: "https://traindriveracademy.com",
      logo: "https://customer-assets.emergentagent.com/job_rail-academy-preview/artifacts/9oj9qdyj_UKTDA.png",
      description:
        "UK Train Driver Academy Ltd delivers specialist railway training, train driver preparation, competence development, human factors, NTS, fatigue, instructor and driver manager development services.",
      areaServed: "GB",
      sameAs: [
        "https://www.traindriverfoundation.com",
        "https://traindriverpsychometrics.co.uk",
        "https://railwaycareers.co.uk",
      ],
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "customer support",
          email: "info@uktraindriveracademy.co.uk",
          areaServed: "GB",
          availableLanguage: ["en-GB"],
        },
      ],
    };
    let el = document.getElementById("org-schema");
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = "org-schema";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  }, []);
  return null;
}
